import React, { createContext, useEffect } from 'react';
import { useLocalStorage } from 'react-use';
export const ThemeContext = /*#__PURE__*/createContext(null);
export const ThemeProvider = ({
  children
}) => {
  const [theme, setTheme] = useLocalStorage('arco-theme', 'light');
  useEffect(() => {
    if (theme === 'dark') {
      document.body.setAttribute('arco-theme', 'dark');
    } else {
      document.body.removeAttribute('arco-theme');
    }
  }, [theme]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      theme: theme || 'light',
      setTheme
    }
  }, children);
};